import styled from '@emotion/styled';

const HorizontalWidgetScrollerContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <Container>{children}</Container>;
};

const Container = styled.div`
  display: flex;
  gap: 12px;
  overflow-x: scroll;
  padding: 0 12px 12px 12px;
  height: 100%;
`;

export { HorizontalWidgetScrollerContainer };
